import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Image } from 'components';
import { media } from "utils/media";
import { FormattedMessage as T } from 'react-intl';

const Banner = ({ className, content }) => (
  <div className={cx('section-info-pricing fvw mb-50', [className])}>
    <div className='content-wrapper'>
        <p><b>{ content.text }</b></p>
        <div className='info-pricing'>
        <Image url={ media(content.icon1) } alt={ content.detail1 } />
        <p className='small ml-10'>{ content.detail1 } <T id="pricing.start">{txt => txt}</T></p>
        </div>
        <div className='info-pricing'>
        <Image url={ media(content.icon2) } alt={ content.detail2 } />
        <p className='small ml-10'>{ content.detail2 } <T id="pricing.month">{txt => txt}</T> / month</p>
        </div>
    </div>
    </div>
);

Banner.propTypes = {
    className: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
};

Banner.defaultProps = {
    className: '',
    content: {},
};

export default Banner;
